import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import useEmpresa from "../../../hooks/useEmpresa";
import IngresoActions from "../../../stores/ingreso/Actions";
import INITIAL_STATE from "../../../stores/ingreso/InitialState";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import TittleLine from "../../../components/Common/TittleLine";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import ModalLoader from "../../../components/Common/ModalLoader";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import Pagination from "../../../components/CustomTable/Pagination";
import Colors from "../../../themes/Colors";
import moment from "moment";
import { DATE_FORMATS, PSS_TYPE, EMPRESA } from "../../../utils/Constant";
import { cleanNumber } from "../../../utils/NumberUtil";
import Tooltip from "../../../components/Common/Tooltip";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
import IngresoService from "../../../services/ingreso/IngresoService";
import DetalleSolicitudHojaQuirurgicaModal from "../components/DetalleSolicitudHojaQuirurgicaModal";
import ActualizarSolicitudHojaQuirurgicaModal from "../components/ActualizarSolicitudHojaQuirurgicaModal";
import {
  OpcionesTipoServicio,
  OpcionesEstatus,
  STATUS_PERMITE_EDITAR_JIRA,
} from "../utils/IngresoConstant";
import { useHistory } from "react-router-dom";

const SolicitudesHojaQuirurgicaScreen = (props) => {
  const {
    formSolicitudesHojaQuirurgicaData,
    buscarSolicitudesHojaQuirurgicaLoading,
    detalleSolicitudHojaQuirurgicaData,
    obtenerDetalleSolicitudHojaQuirurgicaLoading,
    authUserData,
    formSolicitudesHojaQuirurgica,
    buscarSolicitudesHojaQuirurgica,
    obtenerDetalleSolicitudHojaQuirurgica,
    limpiarDetalleSolicitudHojaQuirurgica,
  } = props;

  const empresa = useEmpresa();
  const prestador = authUserData?.prestador;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [descargandoAdjuntoLoading, setDescargandoAdjuntoLoading] =
    useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedSolicitud, setSelectedSolicitud] = useState(null);
  const [updatingSolicitudLoading, setUpdatingSolicitudLoading] =
    useState(false);
  const hasInitialized = useRef(false);

  const history = useHistory();

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  useEffect(() => {
    if (!authUserData || Object.keys(authUserData).length === 0) {
      return;
    }

    if (!isPrimera || !authUserData?.prestador?.permiteHojaQuirurgica) {
      history.push("/dashboard");
      return;
    }

    if (!hasInitialized.current && !buscarSolicitudesHojaQuirurgicaLoading) {
      hasInitialized.current = true;
      const initialData = INITIAL_STATE.formSolicitudesHojaQuirurgicaData;
      formSolicitudesHojaQuirurgica(initialData);

      buscarSolicitudesHojaQuirurgica({
        formSolicitudesHojaQuirurgicaData: initialData,
        tipoPss: prestador?.tipoPss || PSS_TYPE.NO_MEDICO,
        codigoPss: prestador?.codigo,
        params: {
          fechaDesde: initialData.fechaDesde,
          fechaHasta: initialData.fechaHasta,
        },
        formHandler: formSolicitudesHojaQuirurgica,
      });
    }
  }, [
    authUserData,
    isPrimera,
    prestador,
    history,
    formSolicitudesHojaQuirurgica,
    buscarSolicitudesHojaQuirurgica,
    buscarSolicitudesHojaQuirurgicaLoading,
  ]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    limpiarDetalleSolicitudHojaQuirurgica();
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedSolicitud(null);
  };

  const handleUpdateSuccess = () => {
    handleSearch();
  };

  const handleDownloadAttachment = async (id, fileName, numeroSolicitud) => {
    if (!id || !fileName) {
      formSolicitudesHojaQuirurgica({
        ...formSolicitudesHojaQuirurgicaData,
        alertConfig: {
          type: "error",
          title: "¡Error!",
          message: "Información del archivo incompleta para la descarga.",
          onConfirm: () => {
            formSolicitudesHojaQuirurgica({
              ...formSolicitudesHojaQuirurgicaData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      });
      return;
    }

    setDescargandoAdjuntoLoading(true);
    try {
      const numSolicitud =
        numeroSolicitud || detalleSolicitudHojaQuirurgicaData?.numeroSolicitud;
      const response = await IngresoService.descargarAdjuntoHojaQuirurgica(
        id,
        numSolicitud
      );
      const blob = new Blob([response]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file", error);
      formSolicitudesHojaQuirurgica({
        ...formSolicitudesHojaQuirurgicaData,
        alertConfig: {
          type: "error",
          title: "¡Error!",
          message: "No se pudo descargar el archivo adjunto.",
          onConfirm: () => {
            formSolicitudesHojaQuirurgica({
              ...formSolicitudesHojaQuirurgicaData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      });
    } finally {
      setDescargandoAdjuntoLoading(false);
    }
  };

  const onStateChange =
    (key, format = null) =>
    (value) => {
      formSolicitudesHojaQuirurgica({
        ...formSolicitudesHojaQuirurgicaData,
        [key]: format ? format(value) : value,
      });
    };

  const buildParams = (formData = formSolicitudesHojaQuirurgicaData) => {
    const params = {};
    if (formData.numeroCarnet) {
      params.numeroCarnet = formData.numeroCarnet;
    }
    if (formData.fechaDesde) {
      params.fechaDesde = formData.fechaDesde;
    }
    if (formData.fechaHasta) {
      params.fechaHasta = formData.fechaHasta;
    }
    if (formData.fechaIngreso) {
      params.fechaIngreso = formData.fechaIngreso;
    }
    if (formData.numeroIngreso) {
      params.numeroIngreso = formData.numeroIngreso;
    }
    if (formData.servicio) {
      params.servicio = formData.servicio;
    }
    if (formData.estado) {
      params.estado = formData.estado;
    }
    if (formData.numeroSolicitud) {
      params.numeroSolicitud = formData.numeroSolicitud;
    }
    return params;
  };

  const handleSearch = () => {
    const updatedForm = {
      ...formSolicitudesHojaQuirurgicaData,
      paginaActual: 1,
    };
    formSolicitudesHojaQuirurgica(updatedForm);

    const params = buildParams(updatedForm);

    buscarSolicitudesHojaQuirurgica({
      formSolicitudesHojaQuirurgicaData: updatedForm,
      tipoPss: prestador?.tipoPss || PSS_TYPE.NO_MEDICO,
      codigoPss: prestador?.codigo,
      params,
      formHandler: formSolicitudesHojaQuirurgica,
    });
  };

  const handleClear = () => {
    const defaultFechaDesde = moment()
      .subtract(3, "months")
      .format(DATE_FORMATS.middledash_ymd);
    const defaultFechaHasta = moment().format(DATE_FORMATS.middledash_ymd);

    const clearedData = {
      ...formSolicitudesHojaQuirurgicaData,
      numeroCarnet: "",
      fechaDesde: defaultFechaDesde,
      fechaHasta: defaultFechaHasta,
      fechaIngreso: null,
      numeroIngreso: "",
      servicio: "",
      estado: "",
      numeroSolicitud: "",
      paginaActual: 1,
    };
    formSolicitudesHojaQuirurgica(clearedData);

    buscarSolicitudesHojaQuirurgica({
      formSolicitudesHojaQuirurgicaData: clearedData,
      tipoPss: prestador?.tipoPss || PSS_TYPE.NO_MEDICO,
      codigoPss: prestador?.codigo,
      params: {
        fechaDesde: defaultFechaDesde,
        fechaHasta: defaultFechaHasta,
      },
      formHandler: formSolicitudesHojaQuirurgica,
    });
  };

  const columns = [
    {
      title: "Número de solicitud",
      dataIndex: "numeroSolicitud",
      key: "numeroSolicitud",
    },
    {
      title: "Número de ingreso",
      dataIndex: "numeroIngreso",
      key: "numeroIngreso",
    },
    {
      title: "Fecha de ingreso",
      dataIndex: "fechaIngreso",
      key: "fechaIngreso",
      render: (text) =>
        text ? moment(text).format(DATE_FORMATS.middledash_ymd) : "N/A",
    },
    {
      title: "Número carnet",
      dataIndex: "numeroCarnet",
      key: "numeroCarnet",
    },
    {
      title: "Nombre Afiliado",
      dataIndex: "nombreAfiliado",
      key: "nombreAfiliado",
    },
    {
      title: "Tipo de servicio",
      dataIndex: "servicio",
      key: "servicio",
    },
    {
      title: "Estatus de solicitud",
      dataIndex: "estado",
      key: "estado",
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
          <Tooltip text="Ver">
            <button
              type="button"
              aria-label="Ver detalle de solicitud"
              onClick={() => {
                obtenerDetalleSolicitudHojaQuirurgica({
                  numeroSolicitud: record.numeroSolicitud,
                });
                setIsModalOpen(true);
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <EyeOutlined
                style={{
                  color: empresa?.COLOR_PRINCIPAL || Colors.huMyHealth,
                  fontSize: "20px",
                }}
              />
            </button>
          </Tooltip>
          {record.estado === STATUS_PERMITE_EDITAR_JIRA && (
            <Tooltip text="Editar">
              <button
                type="button"
                aria-label="Editar solicitud"
                onClick={() => {
                  setSelectedSolicitud(record);
                  setIsEditModalOpen(true);
                }}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <EditOutlined
                  style={{
                    color: empresa?.COLOR_SECUNDARIO || Colors.huMyHealth,
                    fontSize: "20px",
                  }}
                />
              </button>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={
        formSolicitudesHojaQuirurgicaData?.solicitudes?.length > 0
          ? "relative"
          : "fixed"
      }
    >
      <Section>
        <TittleLine title={"Solicitudes Hoja Quirúrgica"} weight={"bold"} />
      </Section>

      <Section padding={"5px"}>
        <FormWrapper borderColor={Colors.transparent}>
          <Form justifyContent={"space-between"} flexDirection="column">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                columnGap: "30px",
                rowGap: "20px",
                marginBottom: "20px",
                width: "100%",
              }}
            >
              <FormGroup width="calc(33.33% - 20px)">
                <CustomInput
                  label={"Número de carnet"}
                  placeholder={"Número de carnet"}
                  value={formSolicitudesHojaQuirurgicaData.numeroCarnet}
                  onChange={onStateChange("numeroCarnet", cleanNumber)}
                  width="100%"
                />
              </FormGroup>
              <FormGroup width="calc(33.33% - 20px)">
                <CustomInput
                  type="date"
                  label={"Fecha Desde"}
                  value={formSolicitudesHojaQuirurgicaData.fechaDesde}
                  onChange={onStateChange("fechaDesde")}
                  width="100%"
                />
              </FormGroup>
              <FormGroup width="calc(33.33% - 20px)">
                <CustomInput
                  type="date"
                  label={"Fecha Hasta"}
                  value={formSolicitudesHojaQuirurgicaData.fechaHasta}
                  onChange={onStateChange("fechaHasta")}
                  width="100%"
                />
              </FormGroup>
              <FormGroup width="calc(33.33% - 20px)">
                <CustomInput
                  type="date"
                  label={"Fecha de ingreso"}
                  value={formSolicitudesHojaQuirurgicaData.fechaIngreso}
                  onChange={onStateChange("fechaIngreso")}
                  width="100%"
                />
              </FormGroup>
              <FormGroup width="calc(33.33% - 20px)">
                <CustomInput
                  label={"Número de Ingreso"}
                  placeholder={"Número de Ingreso"}
                  value={formSolicitudesHojaQuirurgicaData.numeroIngreso}
                  onChange={onStateChange("numeroIngreso")}
                  width="100%"
                />
              </FormGroup>
              <FormGroup width="calc(33.33% - 20px)">
                <CustomSelect
                  label={"Tipo de servicio"}
                  placeholder={"Seleccionar servicio"}
                  options={OpcionesTipoServicio}
                  value={formSolicitudesHojaQuirurgicaData.servicio}
                  onChange={onStateChange("servicio")}
                  width="100%"
                />
              </FormGroup>
              <FormGroup width="calc(33.33% - 20px)">
                <CustomInput
                  label={"Número de solicitud"}
                  placeholder={"Número de solicitud"}
                  value={formSolicitudesHojaQuirurgicaData.numeroSolicitud}
                  onChange={onStateChange("numeroSolicitud")}
                  width="100%"
                />
              </FormGroup>
              <FormGroup width="calc(33.33% - 20px)">
                <CustomSelect
                  label={"Estatus"}
                  placeholder={"Seleccionar estatus"}
                  options={OpcionesEstatus}
                  value={formSolicitudesHojaQuirurgicaData.estado}
                  onChange={onStateChange("estado")}
                  width="100%"
                />
              </FormGroup>
            </div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-start",
              }}
            >
              <CustomButton
                label={"Buscar"}
                onClick={handleSearch}
                width={"150px"}
                bgColor={empresa?.COLOR_SECUNDARIO}
              />
              <CustomButton
                label={"Limpiar"}
                onClick={handleClear}
                width={"150px"}
                bgColor={Colors.huMyHealth}
              />
            </div>
          </Form>
        </FormWrapper>
      </Section>

      <CustomSeparator height="30px" />

      <Section>
        <CustomTable
          columns={columns}
          dataSource={formSolicitudesHojaQuirurgicaData.solicitudes}
          showPagination={false}
          pageSize={formSolicitudesHojaQuirurgicaData.tamanoPagina}
          headerColor={empresa?.COLOR_PRINCIPAL}
        />
      </Section>
      <CustomSeparator height={"20px"} />
      <Section>
        <Pagination
          currentPage={formSolicitudesHojaQuirurgicaData.paginaActual}
          itemsPerPage={formSolicitudesHojaQuirurgicaData.tamanoPagina}
          totalItems={formSolicitudesHojaQuirurgicaData.totalRegistros}
          onPageChange={(page) => {
            const updatedForm = {
              ...formSolicitudesHojaQuirurgicaData,
              paginaActual: page,
            };
            formSolicitudesHojaQuirurgica(updatedForm);

            const params = buildParams(updatedForm);
            buscarSolicitudesHojaQuirurgica({
              formSolicitudesHojaQuirurgicaData: updatedForm,
              tipoPss: prestador?.tipoPss || PSS_TYPE.NO_MEDICO,
              codigoPss: prestador?.codigo,
              params,
              formHandler: formSolicitudesHojaQuirurgica,
            });
          }}
        />
      </Section>

      <DetalleSolicitudHojaQuirurgicaModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        detalleSolicitud={detalleSolicitudHojaQuirurgicaData}
        empresa={empresa}
        onDownloadAttachment={handleDownloadAttachment}
      />

      <ActualizarSolicitudHojaQuirurgicaModal
        isOpen={isEditModalOpen}
        onClose={handleCloseEditModal}
        solicitud={selectedSolicitud}
        empresa={empresa}
        onUpdateSuccess={handleUpdateSuccess}
        setLoading={setUpdatingSolicitudLoading}
      />

      <CheckRender
        allowed={
          buscarSolicitudesHojaQuirurgicaLoading ||
          obtenerDetalleSolicitudHojaQuirurgicaLoading ||
          descargandoAdjuntoLoading ||
          updatingSolicitudLoading
        }
      >
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={formSolicitudesHojaQuirurgicaData.showAlert}>
        <CustomAlert {...formSolicitudesHojaQuirurgicaData.alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  formSolicitudesHojaQuirurgicaData:
    state.ingreso.formSolicitudesHojaQuirurgicaData,
  buscarSolicitudesHojaQuirurgicaLoading:
    state.ingreso.buscarSolicitudesHojaQuirurgicaLoading,
  detalleSolicitudHojaQuirurgicaData:
    state.ingreso.detalleSolicitudHojaQuirurgicaData,
  obtenerDetalleSolicitudHojaQuirurgicaLoading:
    state.ingreso.obtenerDetalleSolicitudHojaQuirurgicaLoading,
});

const mapDispatchToProps = {
  formSolicitudesHojaQuirurgica: IngresoActions.formSolicitudesHojaQuirurgica,
  buscarSolicitudesHojaQuirurgica:
    IngresoActions.buscarSolicitudesHojaQuirurgica,
  obtenerDetalleSolicitudHojaQuirurgica:
    IngresoActions.obtenerDetalleSolicitudHojaQuirurgica,
  limpiarDetalleSolicitudHojaQuirurgica:
    IngresoActions.limpiarDetalleSolicitudHojaQuirurgica,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SolicitudesHojaQuirurgicaScreen);
